<template>
  <div>
    <l-geo-json
      :geojson="geojsonData.geojson"
      :options="geojsonOptions"
      ref="geolayer"
      @click="mapOnClick()"
    />
    <slot
      :currentItem="currentItem"
      :unit="value.metric"
      :min="min"
      :max="max"
    />
  </div>
</template>
<script>
import store from '@/core/services/store'
import { UPDATE_REGION_ID } from '@/core/services/store/useractivity.module'

import L from 'leaflet'
import { LGeoJson } from 'vue2-leaflet'
import {
  getMin,
  getMax,
  validNumber,
  getPercentage,
  reportColor,
  addDots,
} from '@/core/helpers/temp/util.js'

function onclick({ target }) {
  // update region id for province
  if (typeof target.feature.properties.CC_2 !== 'undefined') {
    store.dispatch(UPDATE_REGION_ID, target.feature.properties.CC_2)
  } else {
    store.dispatch(UPDATE_REGION_ID, '')
  }
}

function mouseover({ target }) {
  target.setStyle({
    weight: this.currentStrokeWidth,
    color: `#${this.currentStrokeColor}`,
    dashArray: '',
  })

  if (!L.Browser.ie && !L.Browser.opera) {
    target.bringToFront()
  }

  let geojsonItem = target.feature.properties
  let tempGeojsonIdKey = geojsonItem[this.geojsonIdKey]

  let item = this.geojsonData.data.find(
    // hack for geojson that have ID in front of param | Humdata map
    (x) => x[this.idKey] == this.newGeojsonIdKey(tempGeojsonIdKey)
  )
  if (!item) {
    this.currentItem = { name: '', value: 0 }
    return
  }

  console.log(this.dose)

  // TARGET Vaksinasi
  const id = this.isDistrict ? 'id_kabupaten' : 'id_provinsi'
  const targetItem = this.geojsonData.denom.find(
    (element) => element[id] == item[id]
  )

  let label
  label = '<ul class="list-unstyled font-size-h6 mt-2">'
  label += `<li class="text-success"><b>Cakupan vaksinasi kumulatif: ${getPercentage(
    item['capaian_harian'],
    targetItem['total']
  )}%</b></li>`
  label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
    item['capaian_harian']
  )} capaian dari ${addDots(targetItem['total'])} sasaran)</span></li>`
  label += `<li class="mt-2">Cakupan vaksinasi lansia: <b>${getPercentage(
    item['lansia_divaksinasi'],
    targetItem['lansia']
  )}%</b></li>`
  label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
    item['lansia_divaksinasi']
  )} capaian dari ${addDots(targetItem['lansia'])} sasaran)</span></li>`
  label += `<li class="mt-2">Cakupan vaksinasi Petugas Publik: <b>${getPercentage(
    item['pet_pub_divaksinasi'],
    targetItem['pet_pub']
  )}%</b></li>`
  label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
    item['pet_pub_divaksinasi']
  )} capaian dari ${addDots(targetItem['pet_pub'])} sasaran)</span></li>`
  label += `<li class="mt-2">Cakupan vaksinasi SDMK: <b>${getPercentage(
    item['sdmkes_divaksinasi'],
    targetItem['sdmkes']
  )}%</b></li>`
  label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
    item['sdmkes_divaksinasi']
  )} capaian dari ${addDots(targetItem['sdmkes'])} sasaran)</span></li>`
  label += `<li class="mt-2">Cakupan vaksinasi masy rentan & umum: <b>${getPercentage(
    item['tahap_3_divaksinasi'],
    targetItem['tahap_3']
  )}%</b></li>`
  label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
    item['tahap_3_divaksinasi']
  )} capaian dari ${addDots(targetItem['tahap_3'])} sasaran)</span></li>`

  // check if dosis 3
  if (this.dose !== 'Dosis 3') {
    label += `<li class="mt-2">Cakupan vaksinasi usia 12-17 th: <b>${getPercentage(
      item['usia_12_17_divaksinasi'],
      targetItem['sasaran_usia_12_17']
    )}%</b></li>`
    label += `<li><span class="text-dark-50 font-size-lg">(${addDots(
      item['usia_12_17_divaksinasi']
    )} capaian dari ${addDots(
      targetItem['sasaran_usia_12_17']
    )} sasaran)</span></li>`
    label += `<li class="mt-2">Cakupan vaksinasi usia 6-11 th: <b>${getPercentage(
      item['usia_6_11_divaksinasi'],
      targetItem['sasaran_usia_6_11']
    )}%</b></li>`
    label += `<li><span class="text-dark-50 font-size-lg">(${this.usia6_11Divaksinasi(
      item['usia_6_11_divaksinasi']
    )} capaian dari ${addDots(
      targetItem['sasaran_usia_6_11']
    )} sasaran)</span></li>`
  }
  label += '</ul>'

  let tempItem = { name: item[this.titleKey], value: label }
  this.currentItem = tempItem
}

function mouseout({ target }) {
  target.setStyle({
    weight: this.strokeWidth,
    color: `#${this.strokeColor}`,
    dashArray: '',
  })
  this.currentItem = { name: '', value: 0 }
}

export default {
  props: {
    geojson: Object,
    data: Array,
    center: Array,
    colorScale: Array,
    titleKey: String,
    idKey: String,
    value: Object,
    extraValues: Array,
    geojsonIdKey: String,
    mapStyle: Object,
    zoom: Number,
    mapOptions: Object,
    strokeColor: { type: String, default: 'fff' },
    currentStrokeColor: { type: String, default: '666' },
    strokeWidth: { type: Number, default: 2 },
    currentStrokeWidth: { type: Number, default: 5 },
    dose: String,
    denom: Array,
    isDistrict: Boolean,
  },
  mounted() {
    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }

    this.$nextTick(() => {
      this.map = this.$refs.geolayer.mapObject // work as expected
    })
  },
  data() {
    return {
      map: null,
      currentItem: { name: '', value: 0 },
      geojsonOptions: {
        style: (feature) => {
          let itemGeoJSONID = feature.properties[this.geojsonIdKey]

          const { data } = this.geojsonData
          let item = data.find(
            (x) => x[this.idKey] == this.newGeojsonIdKey(itemGeoJSONID)
          )
          if (!item) {
            return {
              color: 'white',
              weight: this.strokeWidth,
              fillOpacity: 0.6,
              fillColor: '#eee',
            }
          }
          let valueParam = Number(item[this.value.key])
          if (!validNumber(valueParam)) {
            return {
              color: 'white',
              weight: this.strokeWidth,
            }
          }

          // TARGET
          const { denom } = this.geojsonData
          const id = this.isDistrict ? 'id_kabupaten' : 'id_provinsi'
          const targetItem = denom.find((element) => element[id] == item[id])
          // console.log(targetItem)

          return {
            weight: this.strokeWidth,
            opacity: 1,
            color: `#${this.strokeColor}`,
            dashArray: '3',
            fillOpacity: 0.7,
            fillColor: reportColor(item['capaian_harian'], targetItem['total']),
          }
        },
        onEachFeature: (feature, layer) => {
          layer.on({
            mouseover: mouseover.bind(this),
            mouseout: mouseout.bind(this),
            click: onclick.bind(this),
          })
        },
      },
    }
  },
  computed: {
    min() {
      return getMin(this.geojsonData.data, this.value.key)
    },
    max() {
      return getMax(this.geojsonData.data, this.value.key)
    },
    geojsonData() {
      // return { geojson: { ...this.geojson }, data: this.data }
      return {
        geojson: { ...this.geojson },
        data: this.data,
        denom: this.denom,
      }
    },
  },
  components: {
    LGeoJson,
  },
  methods: {
    deferredMountedTo(parent) {
      this.parent = parent
      for (var i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].deferredMountedTo === 'function') {
          this.$children[i].deferredMountedTo(parent)
        }
      }
    },
    mapOnClick: function () {
      this.$parent.$emit('map-on-click')
    },
    newGeojsonIdKey(param) {
      if (param !== undefined) {
        if (param.includes('ID')) {
          return param.substring(2)
        }
      }

      return param
    },
    usia6_11Divaksinasi(param) {
      return param == null ? 0 : addDots(param)
    },
  },
}
</script>
